import { createTheme } from '@mui/material/styles';

import { HeaderLayout, ThemeCustomizing } from '../types/types';

declare module '@mui/material/styles' {
  interface Palette {
    footer: Palette['primary'],
    header: Palette['primary'],
  }
  interface PaletteOptions {
    footer: PaletteOptions['primary'],
    header: PaletteOptions['primary'];
  }
}

const keyCustomizingIDMobivers = "ahd";
const keyCustomizingIDCreditlife = "cl";
const keyCustomizingIDRhion = "rd";


export { keyCustomizingIDRhion, keyCustomizingIDCreditlife, keyCustomizingIDMobivers };

export const selectTheme = function (customizingid: string | undefined | null): ThemeCustomizing {

  /**
   * Default customizings hinterlegen. Dies kann perspektivisch auch in einen Service-Call verlagert werden, 
   * damit dynamisch Themes geladen werden können.
   * 
   */
  if (keyCustomizingIDMobivers === customizingid) {
    // Autohaus-Direkt ("mobivers")
    return {
      headerLayout: HeaderLayout.FIXED_FULL_WIDTH,
      colors: {
        background: "#fafafa",
        primary: "#0463C2",
        primaryContrast: "#ffffff",
        secondary: "#D63541",
        secondaryContrast: "#ffffff",
        headerBackgroundColor: "#fafafa",
        footerBackgroundColor: "#0463C2",
        footerPrimaryColor: "#fafafa",
      },
      title: 'MOBIVERS LinkedApp',
      logoSrc: process.env.REACT_APP_LINKEDAPP_BACKEND_ROOT + "/static/media/mobivers-logo-rot.svg",
      impressumSrc: 'https://www.mobivers.de/impressum.html',
      agbSrc: 'https://www.mobivers.de/nutzungsbedingungen.html',
      datenschutzSrc: 'https://www.mobivers.de/datenschutz.html',
      copyright: 'RheinLand Versicherungs AG',
      serviceTel: '02131 2010 7140'
    }
  } else if (keyCustomizingIDCreditlife === customizingid) {
    // credit life theme
    return {
      headerLayout: HeaderLayout.FIXED_FULL_WIDTH,
      colors: {
        background: "#ffffff",
        primary: "#4d5357",
        primaryContrast: "#ffffff",
        secondary: "#bad60a",
        secondaryContrast: "#4d5357",
        headerBackgroundColor: "#ffffff",
        headerPrimaryColor: "#4d5357",
        footerBackgroundColor: "#4d5357",
        footerPrimaryColor: "#fafafa",
        answerHeadingBackgroundColor: "#bad60a",
        decentBackground: 'linear-gradient(170deg, rgb(77 83 87 / 5%) 0%, rgba(255, 255, 255, 0) 100%)',
        decentBackgroundEven: 'linear-gradient(170deg, rgb(77 83 87 / 5%) 0%, rgba(255, 255, 255, 0) 100%)',
        decentBackgroundOdd: 'linear-gradient(170deg, rgb(77 83 87 / 5%) 0%, rgba(255, 255, 255, 0) 100%)',
      },
      font: {
        fontFamily: '"FrutigerLTW02-45Light",sans-serif',
        fontSize: 16,
        headlineFontFamily: '"Frutiger LT W04_66 Bold Italic", sans-serif'
      },
      title: 'CreditLife LinkedApp',
      logoSrc: process.env.REACT_APP_LINKEDAPP_BACKEND_ROOT + "/static/media/creditlife-logo.svg",
      impressumSrc: 'https://www.creditlife.net/de/de/impressum.html',
      agbSrc: 'https://www.creditlife.net/de/de/nutzungsbedingungen.html',
      datenschutzSrc: 'https://www.creditlife.net/de/de/datenschutz.html',
      copyright: 'CreditLife AG',
      serviceTel: '02131 2010 7000'
    }
  } else if (keyCustomizingIDRhion === customizingid) {
    // rhion digital theme
    return {
      headerLayout: HeaderLayout.FIXED_FULL_WIDTH,
      colors: {
        background: "linear-gradient(170deg, rgb(188 227 240) 0%, rgb(165 222 206) 100%)",
        backgroundColor: "#cfecf6",
        primary: "#181a1d",
        primaryContrast: "#ffffff",
        info: "#ffffff",
        infoLight: '#ffffffba',
        infoContrast: "#18a075",
        secondary: "#0099cc",
        secondaryContrast: "#ffffff",
        headerBackgroundColor: "#ffffff80",
        headerPrimaryColor: '#181a1d',
        trustElementBackgroundColor: '#000000',
        footerBackgroundColor: "#000000",
        footerPrimaryColor: "#fafafa",
        buttonDisabledBackgroundColor: "rgba(0, 153, 204, 0.5)!important",
        buttonDisabledColor: "rgba(204, 228, 240, 0.5)!important",
        cardbackground: "rgba(255, 255, 255,0.2)",
      },
      font: {
        fontFamily: '"KlavikaWebBasic",sans-serif',
        headlineFontFamily: '"KlavikaWebBasic",sans-serif',
        fontSize: 18,
      },
      title: 'rhion.digital LinkedApp',
      logoSrc: process.env.REACT_APP_LINKEDAPP_BACKEND_ROOT + "/static/media/rhion-logo.svg",
      impressumSrc: 'https://www.rhion.digital/impressum/',
      agbSrc: 'https://rhion.digital/fileadmin/redaktion/DOWNLOADS/Digitales_Postfach/20240626_Nutzungsbedingungen_Digitales_Postfach.pdf',
      datenschutzSrc: 'https://rhion.digital/fileadmin/redaktion/DOWNLOADS/Digitales_Postfach/20231207_Datenschutz_Digitales_Postfach.pdf',
      copyright: 'Rhion Versicherung AG',
      // kontaktdatenAendern: 'https://meinedaten.rhion.digital/#ihreDaten',
      faq: 'https://rhion.digital/kontakt/digitale-post/faq-digitales-postfach',
      technischeUnterstuetzung: 'https://check.rhion.digital/api/v1/widget/cwurghLeMuMKnytlZAGnePlWvcDVFbGv/transactions/redirect',
      serviceTel: '02131 6099 0'
    }
  } else if ("void" === customizingid) {
    // empty theme (Loading short link)
    return {
      headerLayout: HeaderLayout.FIXED_FULL_WIDTH,
      colors: {
        background: "#f2f2f2",
        primary: "#f2f2f2",
        primaryContrast: "#666666",
        secondary: "#f2f2f2",
        secondaryContrast: "#666666",
        headerBackgroundColor: "#f2f2f2",
        footerBackgroundColor: "#f2f2f2",
        footerPrimaryColor: "#f2f2f2",
      },
      title: 'LinkedApp',
      logoSrc: null,
      impressumSrc: 'https://www.rheinland-versicherungen.de/impressum/',
      agbSrc: 'https://www.rheinland-versicherungen.de/nutzungsbedingungen/digitales-postfach',
      datenschutzSrc: 'https://www.rheinland-versicherungen.de/datenschutz/digitales-postfach',
      copyright: 'RheinLand Versicherungs AG',
      serviceTel: '02131 290 0'
    }
  } else {
    // default theme (RheinLand)
    return {
      headerLayout: HeaderLayout.FIXED_FULL_WIDTH,
      colors: {
        background: "#cce4f0",
        font: "#0063ba",
        primary: "#0063ba",
        primaryContrast: "#ffffff",
        secondary: "#009767",
        secondaryContrast: "#ffffff",
        info: "#ffffff",
        infoLight: '#ffffffba',
        infoContrast: "#0063ba",
        headerBackgroundColor: "#ffffff",
        /*headerBackgroundColor: "#cce4f0",*/
        headerPrimaryColor: '#0063ba',
        footerPrimaryColor: "#fafafa",
        trustElementBackgroundColor: 'rgb(164, 202, 222)',
        footerBackgroundColor: "rgb(164, 202, 222)",
        buttonDisabledBackgroundColor: "rgba(0, 151, 103, 0.5)!important",
        buttonDisabledColor: "rgba(204, 228, 240, 0.5)!important",
        cardbackground: "rgba(255, 255, 255,0.2)",
      },
      font: {
        fontFamily: '"Raleway",sans-serif',
        headlineFontFamily: '"Raleway",sans-serif',
      },
      title: 'RheinLand LinkedApp',
      logoSrc: process.env.REACT_APP_LINKEDAPP_BACKEND_ROOT + "/static/media/rheinland.svg",
      impressumSrc: 'https://www.rheinland-versicherungen.de/impressum/',
      agbSrc: 'https://www.rheinland-versicherungen.de/nutzungsbedingungen/digitales-postfach',
      datenschutzSrc: 'https://www.rheinland-versicherungen.de/datenschutz/digitales-postfach',
      copyright: 'RheinLand Versicherungs AG',
      // kontaktdatenAendern: 'https://meinedaten.rheinland-versicherungen.de/#ihreDaten',
      faq: 'https://www.rheinland-versicherungen.de/service/digitales-postfach#faq',
      technischeUnterstuetzung: 'https://check.rheinland-versicherungen.de/api/v1/widget/wbRxhxBphbJmVfsvvGCJmdRVJRSwqYVJ/transactions/redirect',
      serviceTel: '02131 290 0'
    }
  }
}


export const BASIC_THEME = function (customizing: ThemeCustomizing): any {
  return createTheme({
    typography: {
      body1: {
        fontSize: 'inherit'
      },
      h1: {
        fontSize: '24px',
        fontWeight: 700
      },
      h2: {
        fontSize: '18px',
        fontWeight: 700
      },
      h3: {
        fontSize: '14px',
        fontWeight: 700
      },

      fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
      fontWeightMedium: customizing?.font?.fontWeightMedium || 300,
      fontWeightLight: customizing?.font?.fontWeightLight || 100,
      fontWeightBold: customizing?.font?.fontWeightBold || 700,
      fontWeightRegular: customizing?.font?.fontWeightRegular || 300,
      fontSize: customizing?.font?.fontSize || 15,
    },

    palette: {
      primary: {
        main: customizing?.colors?.primary || '#009767',
        //light: '#4444',
        contrastText: customizing?.colors?.primaryContrast || '#4444',
      },
      secondary: {
        main: customizing?.colors?.secondary || '#0069b4',
        //light: '#4444',
        contrastText: customizing?.colors?.secondaryContrast || '#4444',
      },
      info: {
        main: customizing?.colors?.info || '#ffffff',
        light: customizing?.colors?.infoLight || '#ffffff',
        contrastText: customizing?.colors?.infoContrast || '#0063ba',
      },
      footer: {
        main: customizing?.colors?.footerBackgroundColor || '#0069b4',
        //light: '#4444',
        contrastText: customizing?.colors?.footerPrimaryColor || '#4444',
      },
      header: {
        main: customizing?.colors?.headerBackgroundColor || '#0069b4',
        //light: '#4444',
        contrastText: customizing?.colors?.headerPrimaryColor || '#4444',
      },
    },

    components: {
      /*
      MuiRadio: {
        styleOverrides: {
          root: {
            color: '#CCCCCC', // Standardfarbe des Radio Buttons
            borderColor: '#CCCCCC', // Standardfarbe des Radio Buttons
            '&.Mui-checked': {
              color:'#CCCCCC', // Farbe, wenn ausgewählt
            },
            '&$checked': {
              color: '#4B8DF8'
            }
          },

        },
      },
      */
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            '&.la': {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            }
          }
        },
        defaultProps: {
          className: 'la'
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            zIndex: 1,
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            '&.la': {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            }
          }
        },
        defaultProps: {
          className: 'la'
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            "&.errorMessageGrid": {
              borderRadius: '5px',
              padding: "5px",
              border: '1px solid',
              borderColor: 'red',
            }
          }
        }
      },

      MuiTextField: {
        styleOverrides: {
          root: {
            '&.la': {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            },
            //MuiFormControl-root MuiTextField-root MuiTelInput-TextField readonly css-cerna5-MuiFormControl-root-MuiTextField-root
            "&.MuiTelInput-TextField": {
              minWidth: "400px",
              background: 'none',
              "&.MuiInputBase-input": {
                background: 'none!',
              },
              "&.readonly > *": {
                backgroundColor: 'transparent!important',
                borderBottom: "none!important",
                "&::before": {
                  borderBottom: 'none',
                },
              },

            },
          }
        },
        defaultProps: {
          variant: 'filled',
          className: 'la'
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
          }
        }
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            fontWeight: 400,
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            fontSize: 'inherit',
            letterSpacing: 'initial',
            background: '#ffffff',
            backgroundColor: '#ffffff3b',
            "& input": {
              height: '1.4375em',
              paddingTop: 25,
              paddingRight: 12,
              paddingBottom: 8,
              paddingLeft: 12,
            },
          },
          underline: {
            "&::before": {
              borderBottom: '1px solid',
              borderBottomColor: customizing?.colors?.secondaryContrast || '#ffffff',
            },
            "&:hover:not(.Mui-disabled):before": {
              borderBottom: '2px solid',
              borderBottomColor: customizing?.colors?.secondary || '#ffffff',
            },
            "&::after": {
              borderBottom: '2px solid',
              borderBottomColor: customizing?.colors?.secondary || '#ffffff',
            }
          },
          input: {
          }
        },
        defaultProps: {
          className: 'la'
        },
      },

      MuiInputBase: {
        styleOverrides: {
          root: {
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            fontWeight: 400,
            fontSize: 'inherit',
            letterSpacing: 'initial',
            background: '#ffffff',
            backgroundColor: '#ffffff3b',
            '&.la': {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            }
          },
          input: {
          }
        },
        defaultProps: {
          className: 'la'
        }
      },
      MuiInput: {
        styleOverrides: {
          root: {
            background: '#ffffff',
            backgroundColor: '#ffffff3b',
            paddingLeft: 4,
            paddingTop: 4,
          },
          underline: {
            "&::before": {
              borderBottom: '1px solid',
              borderBottomColor: customizing?.colors?.secondaryContrast || '#ffffff',
            },
            "&:hover:not(.Mui-disabled):before": {
              borderBottom: '2px solid',
              borderBottomColor: customizing?.colors?.secondary || '#ffffff',
            },
            "&::after": {
              borderBottom: '2px solid',
              borderBottomColor: customizing?.colors?.secondary || '#ffffff',
            }
          }
        },
        defaultProps: {
          className: 'la'
        },
      },


      MuiDialog: {

        styleOverrides: {

          paper: {
            fontSize: "1em",
            background: "none",
            border: "none",
            width: "90%",
            height: "90%",
            marginBottom: "5%!",
            boxShadow: "none",
            color: customizing?.colors?.primary,

            justifyContent: "end",
            textDecoration: "none",
            "&.popup-content-entry": {
              cursor: "pointer;",
            },
            "a": {
              color: customizing?.colors?.primary,
              textDecoration: "none",
            },
            "&.popup-content-entry:focus": {
              outline: "none!important;"
            }

          },

        }

      },
      MuiSelect: {
        styleOverrides: {
          select: {
            "&:focus": {
              backgroundColor: 'inherit'
            }
          }
        },
        defaultProps: {
          className: 'la'
        },

      },
      MuiCard: {
        styleOverrides: {
          root: {
            background: customizing?.colors?.cardbackground || '#ffffff'
          }
        }
      },
     /*
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            "&.secondarycolorclass" : {
              color: customizing?.colors?.secondary || '#0069b4',
            } 
          }
        }
      },
*/
      MuiButton: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: customizing?.colors?.primary || '#0069b4',
              color: customizing?.colors?.primaryContrast || '#ffffff',
              "@media (hover: none)": {
                backgroundColor: customizing?.colors?.infoContrast || '#0069b4',
                color: customizing?.colors?.primaryContrast || '#ffffff',
              },
            },
            lineHeight: 'initial',
            primary: customizing?.colors?.secondaryContrast || '#ffffff',
            '&.la': {
              background: customizing?.colors?.secondary || '#009767',
              color: customizing?.colors?.secondaryContrast || '#ffffff',
              padding: '0 30px',
              '&:hover': {
                backgroundColor: customizing?.colors?.infoContrast || '#0069b4',
                color: customizing?.colors?.primaryContrast || '#ffffff',
                "@media (hover: none)": {
                  backgroundColor: customizing?.colors?.infoContrast || '#0069b4',
                  color: customizing?.colors?.primaryContrast || '#ffffff',
                },
              },
            },

          },

          text: {

            '&.MuiButton-textPrimary': {
              background: customizing?.colors?.secondary || '#009767',
              color: customizing?.colors?.secondaryContrast || '#ffffff',
            },
            '&.MuiButton-textPrimary:disabled': {
              backgroundColor: customizing?.colors?.buttonDisabledBackgroundColor || '#009767',
              color: customizing?.colors?.buttonDisabledColor || '#ffffff'
            },
            '&.MuiButton-textPrimary:hover': {
              backgroundColor: customizing?.colors?.infoContrast || '#0069b4',
              color: customizing?.colors?.primaryContrast || '#ffffff',
            },
            // Some CSS
            //background: 'linear-gradient(45deg, #0069b4 30%, #009767 90%)',
            background: customizing?.colors?.secondary || '#009767',
            borderRadius: '0',
            border: 0,
            color: customizing?.colors?.secondaryContrast || '#ffffff',
            primary: customizing?.colors?.secondaryContrast || '#ffffff',
            height: 48,
            padding: '0 30px',
            boxShadow: '0 3px 5px 2px rgba(100, 100, 100, .3)',
            //Back Button
            '&.button-wizard-back:hover': {

              border: '3px solid #0063ba'
            },
            '&.button-wizard-back': {
              margin: "none",
              widthMin: "10px",
              width: "10px",
              // Some CSS
              //background: 'linear-gradient(45deg, #0069b4 30%, #009767 90%)',
              background: 'none',
              borderRadius: '0px',
              border: '3px solid #009767',
              borderColor: customizing?.colors?.secondary,
              fontSize: '1.0rem',
              fontWeight: 300,
              primary: customizing?.colors?.primary,
              height: 48,
              //width:"20px!important",
              padding: '0 0',
              paddingLeft: "20px",
              boxShadow: 'none',
            },
            '&.button-wizard-back svg': {
              fontSize: '1.0rem',
              margin: "none",
              padding: "none"
            }
          },
        },
        defaultProps: {
          className: 'la'
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            color: customizing?.colors?.font || '#181a1d',
            fontSize: '13pt',
            fontWeight: '300',
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: customizing?.colors?.backgroundColor || '#fafafa',
            background: customizing?.colors?.background || '#fafafa',
          },
          body: {
            color: customizing?.colors?.font || '#181a1d',
            fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: customizing?.colors?.backgroundColor || '#fafafa',
            background: customizing?.colors?.background || '#fafafa',
          },
          hr: {
            backgroundColor: customizing?.colors?.secondaryContrast || '#ffffff',
            height: "1px",
            border: "none",
          },
          h1: {
            fontFamily: customizing?.font?.headlineFontFamily || 'Roboto, Helvetica, Arial, sans-serif',
          },
          // Fix für Unschönheit im Mui-Datepicker. Kann evtl. mit neuer MUI-Version raus.
          ".MuiPickersDatePickerRoot-toolbar .MuiPickersToolbarButton-toolbarBtn": {
            backgroundColor: 'inherit',
            boxShadow: 'none'
          },
          // Fixes für die gemischte Verwendung des DatePickers mit alter JSS-Engine und Emotion aus MaterialUI 5.
          // Diese Hacks können verschwinden, sobald der offizielle DatePicker in V5 integriert wurde.
          ".MuiFormControl-root": {
            ".MuiFormLabel-root, .MuiInputLabel-root": {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            },
            "&.datepicker .MuiFormLabel-root.MuiInputLabel-shrink": {
              transform: 'translate(12px, 26px) scale(0.75)'
            },
            "&.datepicker .MuiInputLabel-formControl": {
              zIndex: 1,
              transform: 'translate(12px, 36px) scale(1)',
              pointerEvents: 'none',
            },
            "&.datepicker .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover": {
              background: 'rgba(0, 0, 0, 0.09)'
            },
            ".MuiInputBase-root": {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
              background: '#ffffff',
              backgroundColor: '#ffffff3b',
            },
            ".MuiInputBase-root input": {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
              paddingTop: 25,
              paddingRight: 12,
              paddingBottom: 8,
              paddingLeft: 12,
            },
            ".MuiFormHelperText-root": {
              fontFamily: customizing?.font?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
            },
            ".MuiInput-underline": {
              "&::before": {
                borderBottom: '1px solid',
                borderBottomColor: customizing?.colors?.secondaryContrast || '#ffffff',
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: '2px solid',
                borderBottomColor: customizing?.colors?.secondary || '#ffffff',
              },
              "&::after": {
                borderBottom: '2px solid',
                borderBottomColor: customizing?.colors?.secondary || '#ffffff',
              }
            },
          },
          ".MuiPickersToolbar-toolbar": {
            backgroundColor: customizing?.colors?.backgroundColor || '#fafafa',
            background: customizing?.colors?.background || '#fafafa',
          },
          ".MuiBox-root .footerContainer": {
            position: "absolute",
            bottom: "0px",
            marginTop: "auto",
            width: "100%",
            height: "150px"
          },
          '&.dialogCenterInfo &.MuiDialog-paper': {
            backgroundColor: '#ffffff',
            hr: {
              backgroundColor: "grey"
            }

          },
        },
      }
    },
  });
}

